import { useMemo } from 'react'
import type { DataTableInstance, DataTableRow, DataTableRowData } from '../types'
import { getTableRows } from '../utils/row.utils'

export const useTableRows = <TData extends DataTableRowData>(
  table: DataTableInstance<TData>,
): DataTableRow<TData>[] => {
  const {
    getRowModel,
    getState,
    options: { data, enableGlobalFilterRankedResults, positionCreatingRow },
  } = table
  const { creatingRow, expanded, globalFilter, pagination, rowPinning, sorting } = getState()

  const rows = useMemo(
    () => getTableRows(table),
    [
      creatingRow,
      data,
      enableGlobalFilterRankedResults,
      expanded,
      getRowModel().rows,
      globalFilter,
      pagination.pageIndex,
      pagination.pageSize,
      positionCreatingRow,
      rowPinning,
      sorting,
    ],
  )

  return rows
}
